import React from 'react';

const LinksReplacer = ({text}) => {
  if (typeof text !== 'string') return text;
  const linksArray = text.match(/http\S+\b/gi) || [];
  const textArray = text.split(/http\S+\b/i);
  return (
    <div>
      {textArray.map((text, index) => {
        return(
          <span key={index}>
            {text}
            {linksArray[index] ? (
              <a
                href={linksArray[index]}
                target="_blank"
                onClick={e => {e.stopPropagation()}}
              >
                {linksArray[index].match(/https?:\/\/w*\.?([\w\.-]*\b)/i)[1]}
              </a>
            ) : null}
          </span>
        );
      })}
    </div>
  );
}

export default LinksReplacer;



// WEBPACK FOOTER //
// ./src/components/ui/LinksReplacer.jsx